import React from 'react';
import { Button, Flex, normalizeRunStatus, StatusBadge, TagBadge, Text } from '@chatsdet/ui';
import { Eye } from '@phosphor-icons/react';

import { formatDuration, useTestRunAttemptHistory } from '../../../features/workflows/useAgenticRunDetail';
import { testRunLabelMap } from './statusLabels';

export const AttemptHistory: React.FC<{
  testRunId: string;
  onOpenTestRunDetail: (testRunId: string) => void;
}> = ({ testRunId, onOpenTestRunDetail }) => {
  const history = useTestRunAttemptHistory(testRunId);
  if (history.isPending) {
    return <Text className="text-muted-foreground">Loading attempt history...</Text>;
  }
  if (history.isError) {
    return <Text className="text-destructive">Attempt history could not be loaded.</Text>;
  }

  const priorAttempts = history.data.attempts.filter((attempt) => attempt.id !== testRunId);
  return (
    <div className="space-y-2">
      <Text size="xs" className="font-medium text-muted-foreground">
        Attempt history
      </Text>
      <div className="space-y-1.5">
        {priorAttempts.map((attemptRun) => (
          <Flex
            key={attemptRun.id}
            align="center"
            justify="between"
            className="rounded-md border border-border bg-muted/30 px-3 py-2"
          >
            <Flex align="center" gap="sm" className="min-w-0">
              <TagBadge name={`Attempt ${attemptRun.attempt}`} color="gray" hideDot size="sm" />
              <StatusBadge
                status={normalizeRunStatus(attemptRun.status)}
                label={testRunLabelMap[attemptRun.status]}
                size="sm"
              />
              <Text size="xs" className="text-muted-foreground whitespace-nowrap">
                {formatDuration(attemptRun.startedAt, attemptRun.finishedAt)}
              </Text>
            </Flex>
            <Button
              variant="ghost"
              size="sm"
              onPress={() => onOpenTestRunDetail(attemptRun.id)}
              iconLeft={<Eye size={14} />}
            >
              View
            </Button>
          </Flex>
        ))}
      </div>
      {history.data.hasMore && (
        <Text size="xs" className="text-muted-foreground">
          Showing the 20 most recent attempts.
        </Text>
      )}
    </div>
  );
};
